<template>
  <div class="instruction">
    <div class="instruction__inner">
      <div class="instruction__main">
        <BaseTitle
          v-if="title"
          v-bind="title"
          class="instruction__title"
        />
        <BaseText
          v-if="description"
          v-bind="description"
        />
        <BaseButton
          v-if="button"
          v-bind="button"
          class="instruction__button"
          @click="button.action ? button.action() : null"
        />
      </div>
      <div class="instruction__side">
        <img
          v-if="image"
          :src="image"
          class="instruction__image"
          alt=""
        >
      </div>
    </div>
  </div>
</template>

<script>
import BaseTitle from '@/components/BaseTitle.vue';
import BaseText from '@/components/BaseText.vue';
import BaseButton from '@/components/BaseButton.vue';

export default {
  name: 'Instruction',
  components: {
    BaseTitle,
    BaseText,
    BaseButton,
  },
  props: {
    title: {
      type: Object,
      default: null,
    },
    description: {
      type: Object,
      default: null,
    },
    button: {
      type: Object,
      default: null,
    },
    imageName: {
      type: String,
      default: '',
    },
  },
  computed: {
    image() {
      return this.imageName ? require(`@/assets/images/${this.imageName}`) : ''; // eslint-disable-line
    },
  },
};
</script>

<style lang="stylus">
.instruction
  display block

  &__inner
    display flex
    width 100%
    height 100%

  &__side
  &__main
    flex-grow 1
    flex-basis 0
    max-width 50%

  &__main
    align-self center
    padding-right 2em
    padding-left 2em

  &__title
    margin-bottom 0.5em

  &__image
    height 100%
    margin-left auto

  &__button
    margin-top 2em
</style>
